(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-paging"] && !Shopify.designMode) return;
  try {
    
  const track = document.querySelector('.paging_carousel__track');
  const slides = Array.from(track.children);
  const nav = document.querySelector('.paging_carousel__nav');
  const nextButton = document.querySelector('.paging_carousel__button_right');
  const prevButton = document.querySelector('.paging_carousel__button_left');
  const slideControl = document.querySelector('.paging_carousel__indicators');
  const slideIndicators = Array.from(slideControl.children);

  let slideWidth = slides[0].getBoundingClientRect().width;

  const firstSlide = slides[0];
  const firstIndicator = slideIndicators[0];
  firstSlide.classList.add('current_slide');
  firstIndicator.classList.add('current_slide');

  // Arrange slides next to each other
  const setSlidePosition = (slide, index) => {
    slide.style.left = slideWidth * index + 'px';
  };
  slides.forEach(setSlidePosition);

  const moveToSlide = (track, currentSlide, targetSlide) => {
    track.style.transform = 'translateX(-' + targetSlide.style.left + ')';
    currentSlide.classList.remove('current_slide');
    targetSlide.classList.add('current_slide');
  };

  const updateIndicators = (currentIndicator, targetIndicator) => {
    currentIndicator.classList.remove('current_slide');
    targetIndicator.classList.add('current_slide');
  };

  const moveToNextSlide = () => {
    const currentSlide = track.querySelector('.current_slide');
    const currentIndex = slides.indexOf(currentSlide);
    const nextIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
    const nextSlide = slides[nextIndex];
    const currentIndicator = slideControl.querySelector('.current_slide');
    const nextIndicator = slideIndicators[nextIndex];

    moveToSlide(track, currentSlide, nextSlide);
    updateIndicators(currentIndicator, nextIndicator);
  };

  const moveToPrevSlide = () => {
    const currentSlide = track.querySelector('.current_slide');
    const currentIndex = slides.indexOf(currentSlide);
    const prevIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
    const prevSlide = slides[prevIndex];
    const currentIndicator = slideControl.querySelector('.current_slide');
    const prevIndicator = slideIndicators[prevIndex];

    moveToSlide(track, currentSlide, prevSlide);
    updateIndicators(currentIndicator, prevIndicator);
  };

  const resetAutoSlide = () => {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(moveToNextSlide, autoSlideIntervalTime);
  };

  // Click left, move slides to the left
  prevButton.addEventListener('click', () => {
    moveToPrevSlide();
    resetAutoSlide();
  });

  // Click right, move slides to the right
  nextButton.addEventListener('click', () => {
    moveToNextSlide();
    resetAutoSlide();
  });

  // Click slide indicator to jump to that slide
  slideIndicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => {
      const currentSlide = track.querySelector('.current_slide');
      const currentIndicator = slideControl.querySelector('.current_slide');
      const targetSlide = slides[index];
      const targetIndicator = slideIndicators[index];

      moveToSlide(track, currentSlide, targetSlide);
      updateIndicators(currentIndicator, targetIndicator);
      resetAutoSlide();
    });
  });

  // Automatically move to the next slide every 5 seconds
  const autoSlideIntervalTime = 5000;
  let autoSlideInterval = setInterval(moveToNextSlide, autoSlideIntervalTime);

  if (slides.length > 1) {
    nav.style.hidden = 'block';
  } else {
    nav.style.display = 'none';
  }

  // Swipe functionality for mobile
  let startX,
    endX,
    isSwiping = false;

  const handleTouchStart = (event) => {
    startX = event.touches[0].clientX;
    track.style.transition = 'none'; // Disable transition during swipe
    isSwiping = true;
  };

  const handleTouchMove = (event) => {
    if (!isSwiping) return;
    endX = event.touches[0].clientX;
    const deltaX = startX - endX;
    track.style.transform = `translateX(calc(-${currentIndex * slideWidth}px - ${deltaX}px))`; // Move track with touch
  };

  const handleTouchEnd = () => {
    if (!isSwiping) return;
    track.style.transition = ''; // Re-enable transition after swipe
    isSwiping = false;

    const swipeDistance = startX - endX;
    if (swipeDistance > 50) {
      // Swiped left
      moveToNextSlide();
    } else if (swipeDistance < -50) {
      // Swiped right
      moveToPrevSlide();
    } else {
      // Reset to the current slide if swipe distance is too short
      moveToSlide(track, track.querySelector('.current_slide'), track.querySelector('.current_slide'));
    }
    resetAutoSlide();
  };

  track.addEventListener('touchstart', handleTouchStart);
  track.addEventListener('touchmove', handleTouchMove);
  track.addEventListener('touchend', handleTouchEnd);

  // Hide next and previous buttons on mobile
  const handleResize = () => {
    slideWidth = slides[0].getBoundingClientRect().width; // Recalculate slide width
    slides.forEach(setSlidePosition); // Recalculate slide positions

    // Reset to the current slide
    const currentSlide = track.querySelector('.current_slide');
    moveToSlide(track, currentSlide, currentSlide);

    if (window.matchMedia('(max-width: 749px)').matches) {
      nextButton.style.display = 'none';
      prevButton.style.display = 'none';
    } else {
      nextButton.style.display = 'block';
      prevButton.style.display = 'block';
    }
  };

  // Initial check
  handleResize();

  // Listen for window resize
  window.addEventListener('resize', handleResize);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-wrapper');
  const alternativeClass = 'color-scheme-4';
  const defaultClass = 'color-scheme-1';
  const banner = '.banner'

  function handleScroll() {
    if(document.querySelector(banner)) {
      if (window.scrollY <= (window.innerHeight - 87)) {
      header.classList.add(alternativeClass);
      header.classList.remove(defaultClass);
      
    } else {
      header.classList.add('header-wrapper-transition');
      header.classList.add(defaultClass);
      header.classList.remove(alternativeClass);
    }
    }
  }

  window.addEventListener('scroll', handleScroll);
  
  handleScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    const copyDiscountCode = document.getElementById('copy-discount-code');
    const copyGiveawayCode = document.getElementById('copy-giveaway-code');

    if (copyGiveawayCode) {
      copyGiveawayCode.addEventListener('click', (event) => {
        const content = document.getElementById('partner-giveaway-code').textContent.trim();
        navigator.clipboard.writeText(content).catch((err) => {
          console.error('Failed to copy: ', err);
        });
      });
    }

    const moreButton = document.querySelector('#more_button');
    const menuItems = document.querySelector('#menu_items');

    moreButton.addEventListener('click', () => {
      if (menuItems.classList.contains('show')) {
        menuItems.classList.remove('show');
        setTimeout(() => {
          menuItems.style.display = 'none';
        }, 300);
      } else {
        menuItems.style.display = 'block';
        setTimeout(() => {
          menuItems.classList.add('show');
        }, 10);
      }
    });

    document.addEventListener('click', (event) => {
      if (!moreButton.contains(event.target) && !menuItems.contains(event.target)) {
        menuItems.classList.remove('show');
        setTimeout(() => {
          menuItems.style.display = 'none';
        }, 300);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    function setupModal(modalId, openButtonId, closeButtonId) {
      const modal = document.querySelector(modalId);
      const openButton = document.querySelector(openButtonId);
      const closeButton = document.querySelector(closeButtonId);

      openButton.addEventListener('click', () => {
        modal.showModal();
        console.log(`${modalId} opened`);
        document.body.style.overflow = 'hidden';
      });

      closeButton.addEventListener('click', () => {
        modal.close();
        console.log(`${modalId} closed`);
        document.body.style.overflow = '';
      });
    }

    setupModal('#partner_request_modal', '#open-request-modal', '#close-request-modal');
    setupModal('#partner_contact_modal', '#open-contact-modal', '#close-contact-modal');
    setupModal('#partner_about_modal', '#open-about-modal', '#close-about-modal');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    const copyDiscountCode = document.getElementById('copy-discount-code');
    const copyGiveawayCode = document.getElementById('copy-giveaway-code');

    if (copyGiveawayCode) {
      copyGiveawayCode.addEventListener('click', (event) => {
        const content = document.getElementById('partner-giveaway-code').textContent.trim();
        navigator.clipboard.writeText(content).catch((err) => {
          console.error('Failed to copy: ', err);
        });
      });
    }

    const moreButton = document.querySelector('#more_button');
    const menuItems = document.querySelector('#menu_items');

    moreButton.addEventListener('click', () => {
      if (menuItems.classList.contains('show')) {
        menuItems.classList.remove('show');
        setTimeout(() => {
          menuItems.style.display = 'none';
        }, 300);
      } else {
        menuItems.style.display = 'block';
        setTimeout(() => {
          menuItems.classList.add('show');
        }, 10);
      }
    });

    document.addEventListener('click', (event) => {
      if (!moreButton.contains(event.target) && !menuItems.contains(event.target)) {
        menuItems.classList.remove('show');
        setTimeout(() => {
          menuItems.style.display = 'none';
        }, 300);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    function setupModal(modalId, openButtonId, closeButtonId) {
      const modal = document.querySelector(modalId);
      const openButton = document.querySelector(openButtonId);
      const closeButton = document.querySelector(closeButtonId);

      openButton.addEventListener('click', () => {
        modal.showModal();
        console.log(`${modalId} opened`);
        document.body.style.overflow = 'hidden';
      });

      closeButton.addEventListener('click', () => {
        modal.close();
        console.log(`${modalId} closed`);
        document.body.style.overflow = '';
      });
    }

    setupModal('#change_log_modal', '#open-change-log-modal', '#close-change-log-modal');
  });

  } catch(e) { console.error(e); }
})();
})();
